import { Checkbox, FormControl, FormControlLabel, FormHelperText, Typography } from "@mui/material";
import { Controller } from "react-hook-form";
import RightToLeftLayout from "../RightToLeft";

const CheckboxField = ({
  name,
  control,
  label,
  required = false,
  fullWidth = true,
  errorObject,
  className = "",
  disabled = false,
  size = "medium",
  ...rest
}) => {
  return (
    <RightToLeftLayout>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <FormControl
            fullWidth={fullWidth}
            required={required}
            error={!!error}
            className={className}
            component="fieldset"
          >
            <FormControlLabel
              control={
                <Checkbox
                  {...field}
                  checked={!!field.value}
                  onChange={(e) => field.onChange(e.target.checked)}
                  disabled={disabled}
                  size={size}
                  {...rest}
                />
              }
              label={
                <Typography sx={{ ml: 1, userSelect: "none", direction: "ltr !important" }}>
                  {label}
                </Typography>
              }
              labelPlacement="start"
              sx={{ margin: 0 }}
            />
            {(error?.message || errorObject?.message) && (
              <FormHelperText>{error?.message || errorObject?.message}</FormHelperText>
            )}
          </FormControl>
        )}
      />
    </RightToLeftLayout>
  );
};

export default CheckboxField;
